module.exports = __webpack_public_path__ + "static/media/cockroach(19).0a6e2930.PNG";